export default "__VITE_ASSET__DYAsn13e__"